/**
 * created by lei lei
 *工作日程
 */
import React, {Component} from 'react';
import {Calendar, Modal, Input, Button, message,Icon,Tooltip} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import moment from 'moment';
import {connect} from "react-redux";
import request from "../../../base/request";
import {applicationName} from "../../../utils";
import BaseComponent from "../../../base/BaseComponent";
import MyCard from "./MyCard";

class OrderDay extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentClick: moment().format('YYYY-MM-DD'),
            visible: false,
            dataSource: [],
            value: moment(),
            modalList: [],
            inputVal: '',
            plan:[]
        }
    }

    componentDidMount() {
        this.getCalendarByYearAndMonth()
    }

    getCalendarByYearAndMonth() {
        let year = this.state.value.format('YYYY');
        let month = this.state.value.format('MM');
        let date = this.state.value.format('DD');
        let params = {
            year: year,
            month: month
        };
        getCalendarByYearAndMonth(params, res => {
            if (res) {
                let listData = [];
                res.forEach(item => {
                    if (item.day === date) {
                        listData = item.dayInfo;
                    }
                });
                this.setState({
                    dataSource: res,
                    plan: listData
                })
            }
        })
    }

    render() {
        let {permissions} = this.getInfo();
        return (
            <div className={'customCalender'} style={{height:this.props.height}}>
                <MyCard title={'工作日程'} height={this.props.height}>
                    <Calendar
                        value={this.state.value}
                        dateCellRender={this.dateCellRender}
                        onSelect={(e) => {this.dateSelect(e)}}
                        onChange={(e) => {this.dateOnchange(e)}}
                        fullscreen={false}
                    />
                    <Scrollbars
                        autoHide
                        autoHeight
                        autoHeightMax={this.props.height - (48 + 12 + 313)}
                    >
                        {permissions.indexOf(this.sysConfig.addAuthName) !== -1 && <Button block style={{margin: '5px 0'}} onClick={this.clickAdd.bind(this)}>+ 添加</Button>}
                        {
                            this.state.plan.length > 0 && this.state.plan.map((item, index) =>{
                                let statusColor = this.sysConfig.statusColor[item.type];
                                return <PlanItem color={statusColor} name={item.name} />
                            })
                        }
                    </Scrollbars>
                    <style>{`
                     .events {list-style: none;margin: 0;padding: 0;}
                    .events .ant-badge-status {overflow: hidden;white-space: nowrap;width: 100%;text-overflow: ellipsis;font-size: 12px;}
                    .notes-month {text-align: center;font-size: 28px;}
                    .notes-month section {font-size: 28px;}
                    .customCalender .ant-radio-group{display:none}
                    .customCalender .ant-fullcalendar-content{height:20px !important;overflow-y: visible !important;bottom:0px}
                    .customCalender .ant-fullcalendar-date{height:40px !important;}
                    .customCalender .ant-fullcalendar-calendar-body{padding:8px 12px 0 12px}
                    .customCalender .ant-fullcalendar-value{border-radius:12px}
                    .customCalender .ant-fullcalendar-header{padding:0 16px 10px 0}
                    .plan{height:36px;align-items:center;margin-top:8px;line-height:18px;padding-left:10px;border-radius: 5px; }
                    .plan-pointer{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word;overflow:hidden}
                    `}
                    </style>
                </MyCard>
                <Modal
                    title={this.state.currentClick}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                    width={'40vw'}
                    footer={null}
                >
                    <div style={{height: 250,padding: '0 15px'}}>
                        <Scrollbars style={{paddingLeft: 5}} autoHight autoHightMax={250}>
                            {
                                this.state.plan.length > 0 && this.state.plan.map((item, index) =>{
                                    let statusColor = this.sysConfig.statusColor[item.type];
                                    return <PlanItem color={statusColor} name={item.name} showDelete={true} onClick={() =>this.delSchedule(item)}/>
                                })
                            }
                        </Scrollbars>
                    </div>
                    <Input placeholder="请输入" value={this.state.inputVal} onChange={(e) => {
                        this.setState({inputVal: e.target.value})
                    }}/>
                    <div style={{textAlign: 'center', marginTop: 24}}>
                        <Button type="block" style={{background:this.sysConfig.scheduleColor}} onClick={() => {this.addOrderDay(2)}}>添加校历</Button>
                        <Button type="block" style={{background:this.sysConfig.calendarColor, marginLeft: 15}} onClick={() => {this.addOrderDay(3)}}>添加日程</Button>
                    </div>
                </Modal>
            </div>
        )
    }

    //日期变化
    dateOnchange(e) {
        this.state.value = e;
        this.state.inputVal = '';
        this.getCalendarByYearAndMonth()
    }

    getListData = (value, title) => {
        let listData;
        let date = value.format('DD');
        let currentMonth = this.state.value.format('MM');
        let valMonth = value.format('MM');
        if (valMonth !== currentMonth) {
            return [];
        }
        this.state.dataSource.forEach(item => {
            if (item.day === date) {
                listData = item.dayInfo;
            }
        });
        return listData || [];
    };

    getDayTitle = (value) => {
        let title;
        let date = value.format('DD');
        let currentMonth = this.state.value.format('MM');
        let valMonth = value.format('MM');
        if (valMonth !== currentMonth) {
            return [];
        }
        this.state.dataSource.forEach(item => {
            if (item.day === date) {
                if (item.workholiday === '1') {
                    return title = '休'
                } else {
                    title = ''
                }
            }
        });
        return title;
    };

    dateCellRender = (value) => {
        const listData = this.getListData(value);
        const dayTitle = this.getDayTitle(value);
        return (
            <div style={{
                fontSize:12,
                height: 20, overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap', textAlign: 'center',
                color: 'black',
                opacity: '0.3'
            }} title={listData.length && listData[0].name}>
                <div style={{color: 'red', position: 'absolute', top: -20}}>{dayTitle}</div>
                {listData.length > 0 && !listData[0].checked ? listData[0].name : ''}
            </div>
        );
    };

    //点击日期每一项
    dateSelect(e) {
        this.setState({currentClick: e.format('YYYY-MM-DD')});
    }

    clickAdd(){
        let dateList = this.state.currentClick.split('-');
        let year = dateList[0];
        let month = dateList[1];
        let day = dateList[2];
        let params = {
            year: year,
            month: month
        };
        let modalList = [];
        getCalendarByYearAndMonthWithoutLoading(params, res => {
            if (res && res.length > 0) {
                res.forEach(item => {
                    if (item.day === day) {
                        modalList = item.dayInfo?item.dayInfo:[];
                    }
                })
            }
            this.setState({visible: true, modalList: modalList});
        });
    }

    addOrderDay(type) {
        let dateList = this.state.currentClick.split('-');
        let year = dateList[0];
        let month = dateList[1];
        let day = dateList[2];
        this.setState({visible: false});
        if (!this.state.inputVal.trim()) {
            message.info('请输入内容');
            return;
        }
        this.setState({visible: false});
        let params = {
            "year": year,
            "month": month,
            "day": day,
            "name": this.state.inputVal,
            "type": type
        };
        addSchedule(params, res => {
            if (res) {
                message.info('添加成功');
                this.state.inputVal = '';
                this.getCalendarByYearAndMonth()
            }
        })
    }

    //删除功能
    delSchedule(item) {
        let params = {id: item.id};
        delSchedule(params, res => {
            if (res) {
                message.info('删除成功');
                this.state.inputVal = '';
                let currentClick=this.state.currentClick;
                let params = {
                    year: currentClick.split('-')[0],
                    month: currentClick.split('-')[1]
                };
                let modalList = [];
                getCalendarByYearAndMonth(params, res => {
                    if (res && res.length > 0) {
                        res.forEach(item => {
                            if (item.day == currentClick.split('-')[2]) {
                                modalList = item.dayInfo;
                                this.setState({ modalList: modalList});
                            }
                        });
                        this.getCalendarByYearAndMonth();
                    }
                });
            }
        })
    }
}


class PlanItem extends Component{
    render (){
        //(index % 2 === 0 ? '#F0A738' : '#24B481')
        let name = this.props.name;
        return <div className={'plan'} style={{borderLeft:'5px solid #24B481',borderColor:this.props.color}}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"100%"}>
                <tbody>
                    <tr>
                        <td valign={"middle"}>
                            <Tooltip placement={"top"} title={name}><div className={"plan-pointer"} style={{marginRight: 20}}>{name}</div></Tooltip>
                        </td>
                        {
                            this.props.showDelete ?
                                <td valign={"middle"} align={'right'}>
                                    <Icon type="rest" onClick={this.props.onClick}/>
                                </td> : null
                        }

                    </tr>
                </tbody>
            </table>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}
export default connect(mapStateToProps)(OrderDay);


const host = "/cm-sites-" + applicationName() + '/';
//获取工作日程列表
export const getCalendarByYearAndMonth = (body, callBack) => {
    request({url:host + "calendar/getCalendarByYearAndMonth", body, callBack, loading:false});
};
export const getCalendarByYearAndMonthWithoutLoading = (body, callBack) => {
    request({url:host + "calendar/getCalendarByYearAndMonth", body, callBack});
};
//添加日程/校历
export const addSchedule = (body, callBack) => {
    request({url:host + "calendar/addSchedule", method:"post",contentType:'json', body, callBack, loading:false});
};
//删除日程
export const delSchedule = (body, callBack) => {
    request({url:host + "calendar/delSchedule", method:"post", contentType:'json', body, callBack, loading:false});
};